import React, { useRef } from "react";
import { Container } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com5 = () => {
  const ref1 = useRef();
  useScrollFadeIn(ref1);
  return (
    <Container ref={ref1} className="fade-in">
      <img loading="lazy" src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/b001322dHomePhone.png" alt="" />
    </Container>
  );
};

export default Com5;
